import h from 'virtual-dom/h';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState} from "../../../../wireup/AlmeState";
import {Dictionary, Mutator} from "../../../../types/rendering";
import {HistoryMessage, HistoryMessageUser} from "../../../../types/history";
import {VChild} from "virtual-dom";


type ChildRenderer = (message: HistoryMessage) => VChild;


export default class Renderer
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _mutators: Mutator[] = [];
    _childRenderers: ChildRenderer[] = [];


    //#region Public Interface

    constructor(settings: DefaultSettings)
    {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>, mutators: Mutator[], childRenderers: ChildRenderer[]): void
    {
        this._store = store;
        this._mutators = mutators;
        this._childRenderers = childRenderers;
    }

    doesRender(message: HistoryMessage): boolean
    {
        return message.type === this._settings.messageConstants.userInputType;
    }

    getRender()
    {
        return (message): VChild =>
        {
            if (!this.doesRender(message)) return [];

            const { userInputPersonaIconClassName, userInputTextClassName } = this._settings.classNames;
            const userMessage = message as HistoryMessageUser;

            const childNodes = this._childRenderers.map(render => render(userMessage));
            const textNode = h('div', { className: userInputTextClassName }, userMessage.maskedInput ?? "");
            const personaNode = h('div', { className: userInputPersonaIconClassName }, []);
            const messageNode = h('div', this.buildMessageProperties(), [textNode]);

            return h('div', this.buildResponseProperties(userMessage), [...childNodes, messageNode, personaNode]);
        };
    }

    //#endregion



    //#region Helper Methods

    buildResponseProperties(message: HistoryMessageUser): Dictionary
    {
        const properties: Dictionary = { className: this._settings.classNames.userInputClassName };

        if (this._settings.elementIds)
        {
            const { userInputIdNameBase, userMessageDisplayNameIdBase } = this._settings.elementIds;
            const entryId = message.extensionData?.entryId;

            properties.id = entryId ? `${userInputIdNameBase}${entryId}` : null;
            properties.ariaLabelledBy = entryId ? `${userMessageDisplayNameIdBase}${entryId}` : null;
        }

        return this._mutators.reduce((props, mutate) => mutate(props), properties);
    }

    buildMessageProperties(): Dictionary
    {
        const properties: Dictionary = { className: this._settings.classNames.userInputMessageClassName };

        if (this.shouldDisable() || this._settings.accessibility?.focusable?.userInputResponseMessage) { properties.tabIndex = -1; }

        return properties;
    }

    shouldDisable(): boolean
    {
        const { Base, UserMessage } = this._settings.stateLocations.Window;

        return this._store?.getState()[Base][UserMessage.Base][UserMessage.shouldDisable];
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-user/src/renderers/renderer.ts